import Vue from 'vue'
import App from './App.vue'

import Autocomplete from 'v-autocomplete'

// You need a specific loader for CSS files like https://github.com/webpack/css-loader
import 'v-autocomplete/dist/v-autocomplete.css'

import router from './router'
import store from './store'

import VueApexCharts from 'vue-apexcharts'

Vue.use(VueApexCharts)
Vue.use(Autocomplete)

Vue.component('apexchart', VueApexCharts)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
